// extracted by mini-css-extract-plugin
export default {"breadcrumb-item":"BreadcrumbItem_breadcrumb-item__MeFQ+","breadcrumb-item-anchor":"BreadcrumbItem_breadcrumb-item-anchor__Ia5o8"};